/**
 * PerformanceAnalytics export
 * @module features/player-detail/components/PerformanceAnalytics
 */

export { default } from "./PerformanceAnalyticsContainer";
